export default "//yastatic.net/s3/distribution/pythia/frontend/_/c4dc5393e41ffb673392350a4c40a993.jpg";